import { useState, useEffect } from 'react';
import {
  Box,
  alpha,
  styled,
  Button,
  Toolbar
} from '@mui/material';
import HeaderUserbox from './Userbox';
import {OUR_SUGGESTIONS, RECIPES} from "../../../routes";
import {NavLink as RouterLink} from "react-router-dom";
import BrunchDiningIcon from "@mui/icons-material/BrunchDining";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import {ThemeToggle} from "../../../theme/ThemeToggle";
import {useTranslation} from 'react-i18next';
import AISearchButton from "../../../components/AISearchButton/AISearchButton";
import AISearchDrawer from "../../../components/AISearchDrawer/AISearchDrawer";

export const HeaderWrapper = styled(Box)(
  ({ theme }) => `
        color: ${theme.header.textColor};
        padding: ${theme.spacing(0, 2)};
        right: 0;
        z-index: 6;
        background-color: ${alpha(theme.header.background, 0.4)};
        backdrop-filter: blur(3px);
        position: fixed;
        justify-content: space-between;
        width: 100%;
`
);

function BaseLayoutHeaderMenu() {
  const { t } = useTranslation();
  const [drawerOpen, setDrawerOpen] = useState(false);

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
        e.preventDefault();
        setDrawerOpen((prev) => !prev);
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);

  return (
    <HeaderWrapper
      display="flex"
      alignItems="center"
    >
      <Toolbar>
        <Box component="div">
          <Button
            disableRipple
            component={RouterLink}
            to={RECIPES}
            startIcon={<BrunchDiningIcon />}
          >
            {t('navigation.recipes')}
          </Button>
        </Box>
        <Box component="div">
          <Button
            disableRipple
            component={RouterLink}
            to={OUR_SUGGESTIONS}
            startIcon={<CalendarMonthIcon />}
          >
            {t('navigation.batches')}
          </Button>
        </Box>
      </Toolbar>
      <Box display="flex" alignItems="center">
        <HeaderUserbox />
        <ThemeToggle />
        <AISearchButton onClick={() => setDrawerOpen(true)} />
      </Box>
      <AISearchDrawer open={drawerOpen} onClose={() => setDrawerOpen(false)} />
    </HeaderWrapper>
  );
}

export default BaseLayoutHeaderMenu;
